import React from 'react';
import type { ButtonProps } from 'ehs-react';
import { Button, HBox, intl, VBox } from 'ehs-react';

/**
 * Type of the message.
 */
export enum MessageType {
  Info,
  Error
}

/**
 * Props for a {@link Message} component.
 */
export interface MessageInfo {
  text: string;
  type: MessageType;
  button?: Pick<ButtonProps, 'text' | 'onClick'>;
}

/**
 * Shows the message with optional button for the user.
 *
 * @constructor
 * @param messageInfo a {@link MessageInfo}
 * @return a {@link JSX.Element}
 *
 * @author Claus Schabetsberger
 * @author Dusan Mazar
 * @author boris.brtan
 */
export function Message({ button, text, type }: MessageInfo): JSX.Element {
  let title = intl('patientSelfOnboardingPortlet.message.error');
  if (type === MessageType.Info)
    title = intl('patientSelfOnboardingPortlet.message.info');

  return (
    <form className="message-container">
      <HBox className="message-title">
        <img
          className="message-title-icon"
          role="none"
          src="/o/PatientSelfOnboardingPortlet/images/warning_header.png"
        />
        <h1 className="font-18 center sh-font">{title}</h1>
      </HBox>
      <VBox className="message-content font-16 s-font">
        {text}
        {button && (
          <div className="content-button-bar">
            <Button
              scale={'medium'}
              autoFocus={true}
              onClick={button.onClick}
              text={button.text}
              variant="primary"
            />
          </div>
        )}
      </VBox>
    </form>
  );
}
